export const sum = (arr) => arr.reduce((a, b) => a + b, 0);

export const avg = ((arr, fixDecimal) => {
  const average = sum(arr) / arr.length;
  if (average) {
    if (fixDecimal) {
      return average.toFixed(fixDecimal);
    }
    return average;
  }
  return null;
});
